import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Materials from "@/pages/Materials";
import Calculations from "@/pages/Calculations";
import CalculationEditor from "@/pages/CalculationEditor";
import Settings from "@/pages/Settings";
import CalcSettings from "@/pages/CalcSettings";
import ImportPage from "@/pages/ImportPage";
import Recipes from "@/pages/Recipes";
import RecipeEditor from "@/pages/RecipeEditor";
import Customers from "@/pages/Customers";
import Offers from "@/pages/Offers";
import OfferEditor from "@/pages/OfferEditor";
import OfferSettings from "@/pages/OfferSettings";
import AuthPage from "@/pages/AuthPage";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<AuthPage />} />
            <Route path="/register" element={<AuthPage />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/suroviny" element={<Materials />} />
              <Route path="/kalkulace" element={<Calculations />} />
              <Route path="/kalkulace/:id" element={<CalculationEditor />} />
              <Route path="/receptury" element={<Recipes />} />
              <Route path="/receptury/:id" element={<RecipeEditor />} />
              <Route path="/odberatele" element={<Customers />} />
              <Route path="/nabidky" element={<Offers />} />
              <Route path="/nabidky/:id" element={<OfferEditor />} />
              <Route path="/nabidky-nastaveni" element={<ProtectedRoute adminOnly><OfferSettings /></ProtectedRoute>} />
              <Route path="/import" element={<ImportPage />} />
              <Route path="/nastaveni" element={<Settings />} />
              <Route path="/nastaveni-kalkulaci" element={<ProtectedRoute adminOnly><CalcSettings /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
